<style scoped>

</style>
<template>
  <div>
    <div
      v-show="false"
      class="line text-center"
    >
      <div class="search-input">
        <Input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="query_item_path"
        :params="large_page_params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>
    <div class="line">
      <Select
        v-model="source_params.flow_id"
        style="width: 200px"
        placeholder="选择流程"
      >
        <Option
          v-for="flow in flows"
          :key="flow.id"
          :value="flow.id"
        >
          {{ flow.name }}
        </Option>
      </Select>
      <Select
        v-model="source_params.flow_node_id"
        style="width: 200px"
        placeholder="选择节点"
      >
        <Option
          v-for="node in nodes"
          :key="node.id"
          :value="node.id"
        >
          {{ node.name }}
        </Option>
      </Select>
      <Poptip
        placement="bottom"
        transfer
        width="300"
      >
        <Button>节点人员: {{ source_customer_account }}</Button>
        <div
          slot="content"
          class="pop-tip-content"
        >
          <i-input
            v-model="search_source_customer_text"
            placeholder="搜索员工..."
            @on-enter="searchSourceCustomer"
          >
            <span slot="prepend">搜索</span>
            <Button
              slot="append"
              @click="searchSourceCustomer"
            >
              确定
            </Button>
          </i-input>
          <div class="line">
            <Button
              v-for="customer in search_source_customer_result"
              :key="customer.id"
              long
              :disabled="customer.id === source_params.source_customer_id"
              @click="setSourceCustomer(customer)"
            >
              <span>{{ customer.uid }} - </span>
              <span>{{ customer.account }}</span>
            </Button>
          </div>
        </div>
      </Poptip>
      <Button
        type="primary"
        :loading="querying"
        @click="query"
      >
        查询
      </Button>
    </div>
    <div class="line">
      <Poptip
        placement="bottom"
        transfer
        width="300"
      >
        <Button>转移给员工: {{ target_customer_account }}</Button>
        <div
          slot="content"
          class="pop-tip-content"
        >
          <i-input
            v-model="search_target_customer_text"
            placeholder="搜索员工..."
            @on-enter="searchTargetCustomer"
          >
            <span slot="prepend">搜索</span>
            <Button
              slot="append"
              @click="searchTargetCustomer"
            >
              确定
            </Button>
          </i-input>
          <div class="line">
            <Button
              v-for="customer in search_target_customer_result"
              :key="customer.id"
              long
              :disabled="customer.id === source_params.target_customer_id"
              @click="setTargetCustomer(customer)"
            >
              <span>{{ customer.uid }} - </span>
              <span>{{ customer.account }}</span>
            </Button>
          </div>
        </div>
      </Poptip>
      <Button
        v-if="show_transfer_btn"
        type="primary"
        :loading="transfering"
        @click="transfer"
      >
        确认转移
      </Button>
    </div>
    <div class="line">
      <span class="text-large">查询到 {{ node_users.length }} 个流程节点</span>
    </div>
    <Table
      :columns="node_columns"
      :data="node_users"
      size="small"
    />
  </div>
</template>
<script route="/flow/transfer">
  import Util from '../../libs/util';
  import BaseItem from '../mixins/base_item';
  export default {
    /* router_info_start */
    router_info: '/flow/transfer',
    /* router_info_end */

    mixins: [BaseItem],
    data() {
      return {
        query_item_path: Util.api.query_flow,
        source_params: {
          flow_id: 0,
          flow_node_id: 0,
          source_customer_id: 0,
          target_customer_id: 0,
        },
        flows: [],
        flows_hash: {},
        node_users: [],
        querying: false,
        search_source_customer_text: '',
        search_source_customer_result: [],
        search_target_customer_text: '',
        search_target_customer_result: [],
        customer_hash: {},
        transfering: false,
        node_columns: [
          {
            title: '处理人',
            key: 'customer_account'
          },
          {
            title: '流程名称',
            key: 'flow_name'
          },
          {
            title: '流程节点',
            key: 'flow_node_name'
          },
          {
            title: '任务生成时间',
            key: 'created_at'
          }
        ]
      }
    },
    computed: {
      nodes() {
        const flow = this.flows_hash[this.source_params.flow_id];
        return flow ? flow.nodes : [];
      },
      source_customer_account() {
        const customer = this.customer_hash[this.source_params.source_customer_id];
        return customer ? customer.account : '请选择';
      },
      target_customer_account() {
        const customer = this.customer_hash[this.source_params.target_customer_id];
        return customer ? customer.account : '请选择';
      },
      show_transfer_btn() {
        const params = this.source_params;
        return params.flow_node_id && params.source_customer_id && params.target_customer_id && this.node_users.length;
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      handleData(data) {
        this.flows = [];
        data.items.forEach((flow) => {
          this.flows.push(flow);
          this.flows_hash[flow.id] = flow;
        });
      },
      query() {
        if (this.querying) return;
        this.querying = true;
        this.node_users = [];
        Util.ajax.get(Util.api.query_user_flow_node_user, {
          params: this.source_params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.querying = false;
          if (res.code === 1) {
            const node_users = res.data.node_users;
            node_users.forEach((node_user) => {
              this.node_users.push(node_user);
            })
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.querying = false;
          this.$Modal.error({
            title: '错误',
            content: e.message
          });
        });
      },
      searchSourceCustomer() {
        Util.ajax.get(Util.api.query_customer_with_team, {
          params: {
            search: this.search_source_customer_text
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.search_source_customer_result = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((customer) => {
              this.search_source_customer_result.push(customer);
            })
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      setSourceCustomer(customer) {
        this.customer_hash[customer.id] = customer;
        this.source_params.source_customer_id = customer.id;
      },
      searchTargetCustomer() {
        Util.ajax.get(Util.api.query_customer_with_team, {
          params: {
            search: this.search_target_customer_text
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.search_target_customer_result = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((customer) => {
              this.search_target_customer_result.push(customer);
            })
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      setTargetCustomer(customer) {
        this.customer_hash[customer.id] = customer;
        this.source_params.target_customer_id = customer.id;
      },
      transfer() {
        Util.ajax.post(Util.api.batch_transfer_user_flow_node_user, this.source_params).then((response) => {
          return response.data;
        }).then((res) => {
          this.search_target_customer_result = [];
          if (res.code === 1) {
            this.$Modal.success({
              title: '成功',
              content: res.msg
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      }
    }
  }
</script>
